import React, { useEffect, useRef } from 'react'

export function ImageGallery() {
  const scrollContainerRef = useRef(null)
  const images = [
    { src: '/static/examples/form-showcase-1.webp', alt: 'HeyForm Example 1' },
    { src: '/static/examples/form-showcase-2.webp', alt: 'HeyForm Example 2' },
    { src: '/static/examples/form-showcase-3.webp', alt: 'HeyForm Example 3' },
    { src: '/static/examples/form-showcase-4.webp', alt: 'HeyForm Example 4' },
    { src: '/static/examples/form-showcase-5.webp', alt: 'HeyForm Example 5' },
    { src: '/static/examples/form-showcase-6.webp', alt: 'HeyForm Example 6' },
    { src: '/static/examples/form-showcase-7.webp', alt: 'HeyForm Example 7' },
    {
      src: '/static/examples/form-showcase-8.webp',
      alt: 'HeyForm Example 8'
    },
    {
      src: '/static/examples/form-showcase-9.webp',
      alt: 'HeyForm Example 9'
    },
    {
      src: '/static/examples/form-showcase-10.webp',
      alt: 'HeyForm Example 10'
    }
  ]

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current
    const scrollSpeed = 1.5 // 控制滚动速度
    let position = 0
    let animationFrameId

    const animateScroll = () => {
      position += scrollSpeed
      if (position >= scrollContainer.scrollWidth / 2) {
        position = 0 // 重置位置
      }
      scrollContainer.style.transform = `translateX(-${position}px)`
      animationFrameId = requestAnimationFrame(animateScroll)
    }

    animateScroll()

    return () => {
      cancelAnimationFrame(animationFrameId)
    }
  }, [])

  return (
    <div className="mt-2 md:mt-24">
      <div className="">
        <div className="overflow-hidden whitespace-nowrap">
          <div className="flex" ref={scrollContainerRef}>
            {/* 渲染图片 */}
            <div className="flex">
              {images.map((image, index) => (
                <img
                  key={index}
                  src={image.src}
                  alt={image.alt}
                  className="w-96 h-56 mx-2 object-contain transition duration-300 rounded-t-xl"
                />
              ))}
              {/* 复制内容以实现无缝滚动 */}
              {images.map((image, index) => (
                <img
                  key={`copy-${index}`}
                  src={image.src}
                  alt={image.alt}
                  className="w-96 h-56 mx-2 object-contain transition duration-300"
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ImageGallery

export function BrandedForms() {
  return (
    <div className="relative overflow-hidden bg-slate-900 pt-24">
      <div className="max-w-7xl mx-auto px-4 md:px-0">
        <div className="grid items-center">
          <div className="max-w-3xl mx-auto text-center mt-12">
            <h2 className="mt-6 text-4xl md:text-7xl font-bold text-white font-hdg">
              Forms that actually feel like your brand
            </h2>
            <p className="max-w-2xl mx-auto mt-6 text-lg lg:text-xl text-slate-300 font-hdg">
              Customize everything — from fonts and colors to layouts and flow — so your forms don’t just look like your brand, they feel like it.
            </p>
            <a
              className="inline-block mt-6 text-lg lg:text-xl text-blue-300 font-semibold font-hdg hover:underline"
              href="https://my.heyform.net/sign-up"
            >
              Design your form →
            </a>
          </div>

            <div className="h-auto mt-12">
              <div className="max-w-6xl overflow-hidden rounded-lg bg-white shadow-[0_24px_70px_rgba(15,23,42,0.24)] md:rounded-xl lg:rounded-2xl">
                <img
                  src="/static/customization.webp"
                  alt="HeyForm Customization"
                  className="block h-auto w-full max-h-[560px] object-cover object-left-top"
                />
              </div>
            </div>
        </div>
      </div>
      <ImageGallery />
    </div>
  )
}
